import { TextFieldElement } from 'react-hook-form-mui';

export function Comment({ defaultProps, name = 'comment', disabled = false }) {
    return <TextFieldElement label="Comment" name={name} id={name} multiline disabled={disabled} {...defaultProps} />;
}
